import "./BoxCard.css";

function BoxCard({ box, onRent, labels }) {
  const usesContainedImage = ["bike-towbar", "bike-rear", "ski-rack", "snow-chain"].includes(box.category)
    || box.name === "Thule Force XT S";
  const mountingLocation = labels.bikeMountLocations?.[box.category];

  const primaryFact = (() => {
    if (box.category === "roof-box") {
      return `${box.volume} ${labels.liters}`;
    }

    if (box.category === "roof-rail") {
      return labels.roofRailFact;
    }

    if (box.category === "bike-roof") {
      return box.capacityLabel ?? labels.bikeRoofFact;
    }

    if (box.category === "bike-towbar" || box.category === "bike-rear") {
      return box.capacityLabel ?? labels.bikeTowbarFact;
    }

    if (box.category === "ski-rack") {
      return labels.skiRackCapacity;
    }

    if (box.category === "snow-chain") {
      return box.capacityLabel ?? "-";
    }

    return `${box.volume} ${labels.liters}`;
  })();

  function openDetails() {
    onRent(box);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openDetails();
    }
  }

  return (
    <article
      className="box-card"
      role="button"
    tabIndex={0}
    onClick={openDetails}
    onKeyDown={handleKeyDown}
    >
      <div className="box-card-image-button">
        <img
          className={`box-card-image ${usesContainedImage ? "box-card-image--contain" : ""}`}
          src={box.imageUrl}
          alt={box.name}
          width="640"
          height="440"
          loading="eager"
          decoding="async"
          fetchPriority="auto"
        />
      </div>

      <div className="box-card-body">
        <div className="box-card-title-button">
          <h3>{box.name}</h3>
        </div>

        <div className="box-card-facts">
          <span>{box.price} {labels.pricePerDay}</span>
          <span>{primaryFact}</span>
          {mountingLocation && <span>{mountingLocation}</span>}
        </div>

        <div className="box-card-action">
          {labels.details}
        </div>
      </div>
    </article>
  );
}

export default BoxCard;
